import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MeuLocalComponent } from './meu-local.component';

/** Modal pós-login para definir (ou pular) o local que o usuário comanda. */
@Component({
  selector: 'app-meu-local-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MeuLocalComponent],
  template: `
    <div class="dialog-header">
      <mat-icon>my_location</mat-icon>
      <h2 mat-dialog-title>Definir meu local</h2>
    </div>
    <mat-dialog-content>
      <app-meu-local [isDialog]="true" (done)="fechar()"></app-meu-local>
    </mat-dialog-content>
  `,
  styles: [`
    .dialog-header {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 16px 24px 0;

      mat-icon { color: #1976d2; }
      h2 { margin: 0; font-size: 1.2rem; }
    }
    mat-dialog-content { padding-top: 8px; }
  `],
})
export class MeuLocalDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<MeuLocalDialogComponent>) {}

  fechar(): void {
    this.dialogRef.close();
  }
}
